<ul>
  @for (tab of tabs; track tab) {
    <li (click)="selectTab(tab)" [class]="tab.active ? 'highlight' : ''">
      {{ tab.tabTitle }}
    </li>
  }
</ul>
<ng-content></ng-content>
